export const fdmMarkup = String.raw`    <div class="page-container">
        <h1 class="page-title">FLIGHT DATA MONITORING</h1>
        <p class="page-subtitle">FDM Program Topics & Operational Guidelines</p>

        <div class="fdm-intro">
            <p>All flights are manually reviewed post-flight to ensure SOP adherence.</p>
            <p>Click on any topic below for detailed information.</p>
        </div>

        <div class="fdm-grid">

            <div class="fdm-card" data-fdm-id="madeira">
                <span class="fdm-tag">Special Airport</span>
                <div class="fdm-card-header">
                    <div>
                        <h3>Madeira (LPMA) Procedures</h3>
                        <p class="fdm-preview">Complex airfield procedures, RNP approaches only, wind limits and terrain hazards.</p>
                    </div>
                    <span class="fdm-arrow">&#8250;</span>
                </div>
            </div>

            <div class="fdm-card" data-fdm-id="dortmund">
                <span class="fdm-tag">Ground Ops</span>
                <div class="fdm-card-header">
                    <div>
                        <h3>Dortmund (EDLW) Taxiway B</h3>
                        <p class="fdm-preview">Taxiway B prohibited for RWY24 vacating due to width and weight limits.</p>
                    </div>
                    <span class="fdm-arrow">&#8250;</span>
                </div>
            </div>

            <div class="fdm-card" data-fdm-id="taxi">
                <span class="fdm-tag">Ground Ops</span>
                <div class="fdm-card-header">
                    <div>
                        <h3>Taxi Speed Limitations</h3>
                        <p class="fdm-preview">Maximum speeds for runways, taxiways, ramps and turns.</p>
                    </div>
                    <span class="fdm-arrow">&#8250;</span>
                </div>
            </div>

            <div class="fdm-card" data-fdm-id="split">
                <span class="fdm-tag">Approach</span>
                <div class="fdm-card-header">
                    <div>
                        <h3>Split (LDSP) RWY23</h3>
                        <p class="fdm-preview">VOR-B circling approach only. RNAV and Visual approaches prohibited.</p>
                    </div>
                    <span class="fdm-arrow">&#8250;</span>
                </div>
            </div>

            <div class="fdm-card" data-fdm-id="touchdown">
                <span class="fdm-tag">Landing</span>
                <div class="fdm-card-header">
                    <div>
                        <h3>Touchdown Zone & Pitch Limits</h3>
                        <p class="fdm-preview">Land within TDZ. A320 max 10° pitch, A321 max 7.5° pitch.</p>
                    </div>
                    <span class="fdm-arrow">&#8250;</span>
                </div>
            </div>

            <div class="fdm-card" data-fdm-id="engine">
                <span class="fdm-tag">Engine</span>
                <div class="fdm-card-header">
                    <div>
                        <h3>Engine Warm-Up & Cool-Down</h3>
                        <p class="fdm-preview">5-min warm-up before takeoff, 3-min cool-down after landing.</p>
                    </div>
                    <span class="fdm-arrow">&#8250;</span>
                </div>
            </div>

            <div class="fdm-card" data-fdm-id="stabilization">
                <span class="fdm-tag">Approach</span>
                <div class="fdm-card-header">
                    <div>
                        <h3>Stabilization Criteria</h3>
                        <p class="fdm-preview">Stabilized by 1000ft AAL (500ft for circling). Correct configuration sequence.</p>
                    </div>
                    <span class="fdm-arrow">&#8250;</span>
                </div>
            </div>

            <div class="fdm-card" data-fdm-id="fuel">
                <span class="fdm-tag">Fuel</span>
                <div class="fdm-card-header">
                    <div>
                        <h3>Minimum Off Block Fuel</h3>
                        <p class="fdm-preview">Never pushback below MOBF. Check MIN BLOCK in SimBrief OFP.</p>
                    </div>
                    <span class="fdm-arrow">&#8250;</span>
                </div>
            </div>

            <div class="fdm-card" data-fdm-id="chisinau">
                <span class="fdm-tag">Special Airport</span>
                <div class="fdm-card-header">
                    <div>
                        <h3>Chișinău (LUKK) RWY 09/27</h3>
                        <p class="fdm-preview">RWY 09/27 is Taxiway D. Only use when RWY 08/26 closed per NOTAM.</p>
                    </div>
                    <span class="fdm-arrow">&#8250;</span>
                </div>
            </div>

        </div>

        <div class="general-inquiry" style="margin-top: 50px;">
            <h3>Questions?</h3>
            <p>Contact the FDM team for any procedural questions.</p>
        </div>
    </div>

    <!-- MADEIRA MODAL -->
    <div id="modal-madeira" class="fdm-modal">
        <div class="fdm-modal-content">
            <button class="fdm-modal-close">&times;</button>
            <h2>Madeira (LPMA) - Special Airport Procedures</h2>
            <p class="modal-intro">The FDM team would like to reinforce critical approach, landing, and ground operation procedures for Madeira.</p>

            <p>Madeira is classified as a special/complex airfield due to terrain, wind effects, turbulence, and circling manoeuvres. Strict adherence to OM-C procedures and limitations is mandatory for all vWZZ flights. This airfield does not tolerate rushed or unstable operations — preparation and discipline are essential.</p>

            <h4>Approach Restrictions & Authorized Procedures</h4>
            <p class="fdm-prohibited">Guided visual approaches are prohibited for WAH/WMT until further notice.</p>
            <p class="fdm-approved">Only approved procedures for vWZZ operations:</p>
            <ul>
                <li>RNP A RWY 05</li>
                <li>RNP B RWY 23</li>
            </ul>
            <p>Any other procedure selection is not authorized, even if available in-sim.</p>

            <h4>Wind, Terrain & Environmental Hazards</h4>
            <p>Expect:</p>
            <ul>
                <li>Strong/variable crosswinds</li>
                <li>Turbulence & windshear</li>
                <li>Up/down drafts</li>
                <li>Terrain-induced vortexes from restraining walls</li>
                <li>Rapid wind variation along runway length</li>
            </ul>
            <p>Published wind limits are maximum values. Strict compliance is required.</p>

            <h4>Approach Technique Considerations</h4>
            <ul>
                <li>PAPIs set to 3° both runways</li>
                <li>Stabilize early — avoid float or long flare</li>
                <li>Configure early (especially RWY 23) to avoid EGPWS configuration alerts</li>
                <li>Possible EGPWS Mode 2A near FUN VOR
                    <ul>
                        <li>Cross level/higher if visual</li>
                        <li>Keep speed at or below 150 kt if able</li>
                    </ul>
                </li>
                <li>Terrain may trigger EGPWS cautions/warnings
                    <ul>
                        <li>Obey unless clearly visual</li>
                        <li>ASR mandatory after any warning/caution</li>
                    </ul>
                </li>
                <li>Include circling profile & energy management in TEM brief</li>
                <li>Use GELO and ROSARIO (ROSRO) for situational awareness and lineup</li>
            </ul>

            <h4>Runway & Airport Considerations</h4>
            <p>Operational constraints apply on every visit:</p>
            <ul>
                <li>Limited apron parking space</li>
                <li>Follow-me vehicle used for parking</li>
                <li>Backtrack required for both runways</li>
                <li>Authorization required for refuelling with passengers onboard</li>
            </ul>
            <p>Plan taxi and turnaround accordingly.</p>

            <h4>Take-Off Procedures & Limitations</h4>
            <ul>
                <li>RWY 23 is the preferential take-off runway</li>
                <li>TOGA thrust must be used when turbulence or downdraughts are reported</li>
                <li>Wind limits based on 2-minute mean wind (MID anemometer)</li>
                <li>Due to higher landing minima, a take-off alternate may be required
                    <ul>
                        <li>GCLA and LPPS are within 250 NM</li>
                    </ul>
                </li>
            </ul>
            <div class="fdm-warning">
                <p>Do not attempt flex take-off when conditions are marginal.</p>
            </div>

            <h4>Landing Considerations</h4>
            <p class="fdm-prohibited">Landings with standing water not authorized.</p>
            <p class="fdm-prohibited">Do not operate above published wind limits.</p>
            <p>Surface wind reported at 4 locations:</p>
            <ul>
                <li>RWY 23 threshold</li>
                <li>RWY 05 threshold</li>
                <li>Rosario</li>
                <li>Tower (MID)</li>
            </ul>
            <p><strong>If unstable or unsafe — GO AROUND</strong></p>

            <div class="fdm-section">
                <p><strong>RWY 05 (Preferential Landing):</strong></p>
                <ul>
                    <li>Uphill slope</li>
                    <li>Keep curved approach lights to the left</li>
                    <li>Visual illusion of being high</li>
                    <li>Max turbulence near Rosario</li>
                </ul>
            </div>

            <div class="fdm-section">
                <p><strong>RWY 23:</strong></p>
                <ul>
                    <li>High terrain on right</li>
                    <li>Turbulence/downdrafts near valley opening</li>
                    <li>Strong SW winds may cause "vortex bubble" below 100 ft</li>
                    <li>Consider speed increment (max VLS +15 kt) if reported</li>
                    <li>Touchdown at 1000 ft markers</li>
                    <li>Go-around required if not landed by TDZ lights (600 m)</li>
                </ul>
            </div>

            <h4>Stabilization Reminder</h4>
            <p>Terrain and circling geometry may place aircraft on extended centreline below 500 ft AAL. Strict energy and profile management is essential to remain compliant.</p>

            <h4>Non-Compliance</h4>
            <div class="fdm-warning">
                <p>Failure to follow Madeira procedures may result in:</p>
                <ul style="margin: 8px 0 0 18px; padding: 0;">
                    <li>FDM penalty points</li>
                    <li>PIREP invalidation</li>
                </ul>
            </div>

            <div class="fdm-success">
                <p><strong>Quick Compliance Tips:</strong></p>
                <ul>
                    <li>Full briefing mandatory</li>
                    <li>Select correct RNP procedure only</li>
                    <li>Configure early</li>
                    <li>Respect wind limits</li>
                    <li>Expect turbulence</li>
                    <li>Plan backtrack</li>
                    <li>Use TOGA when required</li>
                    <li>When in doubt — GO AROUND</li>
                </ul>
            </div>

            <p class="fdm-author"><strong>Dejw</strong> – Flight Operations Manager | FDM Team</p>
        </div>
    </div>

    <!-- DORTMUND MODAL -->
    <div id="modal-dortmund" class="fdm-modal">
        <div class="fdm-modal-content">
            <button class="fdm-modal-close">&times;</button>
            <h2>Dortmund (EDLW) - Taxiway B Restriction</h2>
            <p class="modal-intro">The FDM team has identified several aircraft vacating RWY24 via Taxiway B at Dortmund.</p>

            <p>This exit is not authorized for vWZZ operations and must not be used under any circumstances.</p>

            <h4>Taxiway B – Prohibited for Vacating RWY24</h4>
            <p>According to the Aerodrome Operating Information (AOI), Taxiway B has the following limitations:</p>
            <ul>
                <li><strong>Width:</strong> 15 m / 49 ft</li>
                <li><strong>Maximum weight:</strong> 30 t / 66,139 lbs</li>
                <li><strong>Maximum main gear track width:</strong> 4.5 m / 14.7 ft</li>
            </ul>
            <p>These limits are below the requirements of our fleet, making the taxiway unsuitable and unsafe for our aircraft types.</p>
            <p>Attempting to vacate here would be illegal, unrealistic, and outside certified ground maneuvering limits.</p>

            <h4>Required Procedure</h4>
            <ul>
                <li>Plan ahead and vacate RWY24 at the end</li>
                <li>Do not accept or plan Taxiway B, even if performance approves or instructed by default simulator ATC</li>
            </ul>

            <h4>Non-Compliance Penalties</h4>
            <div class="fdm-warning">
                <p>Failure to comply will result in:</p>
                <ul style="margin: 8px 0 0 18px; padding: 0;">
                    <li>Penalty points on your PIREP</li>
                    <li>Possible PIREP invalidation for repeated or deliberate violations</li>
                </ul>
            </div>

            <div class="fdm-success">
                <p><strong>Quick Compliance Tips:</strong></p>
                <ul>
                    <li>Brief taxi routing during arrival preparation</li>
                    <li>Check airport charts/AOI notes before landing</li>
                    <li>Ignore tight or "shortcut" exits that appear in-sim but are not suitable</li>
                    <li>When in doubt, roll further and exit safely</li>
                </ul>
            </div>

            <div class="fdm-images">
                <div class="fdm-images-grid">
                    <img src="/images/fdm/dtm1.png" alt="Dortmund Taxiway B Reference 1">
                    <img src="/images/fdm/dtm2.png" alt="Dortmund Taxiway B Reference 2">
                    <img src="/images/fdm/dtm3.png" alt="Dortmund Taxiway B Reference 3">
                    <img src="/images/fdm/dtm4.png" alt="Dortmund Taxiway B Reference 4">
                </div>
            </div>

            <p class="fdm-author"><strong>Dejw</strong> – Flight Operations Manager | FDM Team</p>
        </div>
    </div>

    <!-- TAXI SPEED MODAL -->
    <div id="modal-taxi" class="fdm-modal">
        <div class="fdm-modal-content">
            <button class="fdm-modal-close">&times;</button>
            <h2>Taxi Speed Limitations & Taxi Overspeed</h2>
            <p class="modal-intro">The FDM team has observed multiple events of excessive taxi speeds during ground operations across recent flights.</p>

            <p>Taxi overspeed significantly increases the risk of loss of control, excessive brake wear, structural stress, and ground collisions, and does not reflect realistic or professional airline operations.</p>
            <p>To maintain safety and realism at vWZZ, all pilots must strictly comply with the published ground maneuvering speed limits.</p>

            <h4>Maximum Taxi Speeds</h4>
            <p>The following limits apply at all times:</p>
            <ul>
                <li><strong>Below 50 kts</strong> while taxiing on runways</li>
                <li><strong>Below 30 kts</strong> on straight taxiways</li>
                <li><strong>Below 20 kts</strong> where a taxiway passes through a ramp area</li>
                <li><strong>Below 15 kts</strong> on normal taxiway turns</li>
                <li><strong>Below 10 kts</strong> for tight 90° turns or 180° turn-arounds</li>
            </ul>

            <h4>Reference</h4>
            <p>These limitations are published in <strong>vWZZ OMB REV 4 – "LIMITATIONS FOR GROUND MANEUVERING"</strong> and must be respected on every flight.</p>

            <h4>Why This Matters</h4>
            <p>Excessive taxi speed can lead to:</p>
            <ul>
                <li>Reduced steering effectiveness and poor turn performance</li>
                <li>Increased brake and tire wear</li>
                <li>Higher risk of runway/taxiway excursions</li>
                <li>Unrealistic operation and negative FDM scoring</li>
            </ul>
            <p><strong>Remember: Safe taxi = smooth and controlled, never rushed.</strong></p>

            <h4>Non-Compliance Penalties</h4>
            <div class="fdm-warning">
                <p>Failure to comply with taxi speed limitations will result in:</p>
                <ul style="margin: 8px 0 0 18px; padding: 0;">
                    <li>Penalty points on your PIREP</li>
                    <li>Possible PIREP invalidation for repeated or severe violations</li>
                </ul>
            </div>

            <div class="fdm-success">
                <p><strong>Quick Compliance Tips:</strong></p>
                <ul>
                    <li>Brief your taxi route in advance</li>
                    <li>Reduce speed early before turns — don't brake aggressively at the last second</li>
                    <li>Use minimal thrust and allow the aircraft to roll</li>
                    <li>Anticipate tight corners and congested ramp areas</li>
                    <li>When in doubt: slower is always better</li>
                </ul>
            </div>

            <p>Professional operations start on the ground — not only in the air.</p>

            <p class="fdm-author"><strong>Dejw</strong> – Flight Operations Manager | FDM Team</p>
        </div>
    </div>

    <!-- SPLIT MODAL -->
    <div id="modal-split" class="fdm-modal">
        <div class="fdm-modal-content">
            <button class="fdm-modal-close">&times;</button>
            <h2>Split (LDSP) RWY23 Approach</h2>
            <p class="modal-intro">The FDM team has reviewed several approaches into Split RWY23 and identified non-compliant procedures being flown.</p>

            <p>To ensure realism, safety, and alignment with vWZZ operations, we must emphasize the following:</p>

            <h4>Prohibited Approaches</h4>
            <p class="fdm-prohibited"><strong>Visual Approach RWY23</strong> – Not permitted under any circumstances in vWZZ operations.</p>
            <p class="fdm-prohibited"><strong>RNAV RWY23</strong> – Not authorized for our operations and must not be flown.</p>
            <p>These procedures may appear available in the simulator, but they are strictly prohibited for vWZZ flights.</p>

            <h4>Approved Approach – VOR-B RWY23</h4>
            <p class="fdm-approved">The only valid procedure for RWY23 at Split is the <strong>VOR-B approach</strong>, which is a circling approach:</p>
            <ul>
                <li>Must be briefed and executed in accordance with published charts</li>
                <li>Proper circling minima must be respected</li>
                <li>Demands precise energy management and situational awareness due to terrain and operational constraints</li>
            </ul>

            <h4>Why the Restriction?</h4>
            <ul>
                <li>The RNAV (GNSS) 23 procedure requires compliance with the standard stabilization altitude of 1000 ft AAL</li>
                <li>The VOR-B to RWY23 is a circling approach, which applies different criteria: stabilization must be achieved by 500 ft AAL</li>
                <li>The "established on the landing runway axis" item of the 500 ft stabilization criteria may be disregarded for this approach</li>
            </ul>
            <p>This makes the VOR-B the only compliant and realistic approach for RWY23 in vWZZ operations.</p>
            <p class="fdm-prohibited">Flying RNAV 23 or Visual approaches disregards these stabilization requirements and is therefore not permitted.</p>

            <h4>Non-Compliance Penalties</h4>
            <div class="fdm-warning">
                <p>Failure to comply with the above procedures will result in:</p>
                <ul style="margin: 8px 0 0 18px; padding: 0;">
                    <li>Penalty points on your PIREP</li>
                    <li>Possible PIREP rejection in case of repeated or serious violations</li>
                </ul>
            </div>

            <div class="fdm-success">
                <p><strong>Quick Compliance Tips:</strong></p>
                <ul>
                    <li>Always brief the VOR-B to RWY23 before arrival into Split</li>
                    <li>Remember: stabilization requirement is 500 ft AAL for circling, not 1000 ft</li>
                    <li>Avoid selecting RNAV 23 or Visual approaches in the MCDU</li>
                    <li>Fly the approach as an EARLY stabilized approach</li>
                </ul>
            </div>

            <p class="fdm-author"><strong>FDM Team</strong></p>
        </div>
    </div>

    <!-- TOUCHDOWN MODAL -->
    <div id="modal-touchdown" class="fdm-modal">
        <div class="fdm-modal-content">
            <button class="fdm-modal-close">&times;</button>
            <h2>Touchdown Zone & Pitch Limitations</h2>
            <p class="modal-intro">This is a reminder about the importance of landing within the designated touchdown zone on all approaches, and adhering to aircraft pitch limitations during landing.</p>

            <h4>Why It Matters</h4>
            <p>Landing beyond the touchdown zone can lead to unstable approaches, runway excursions, and other dangerous outcomes. <strong>This practice is strictly against vWZZ operational standards and real-world aviation procedures.</strong></p>

            <h4>What is the Touchdown Zone?</h4>
            <p>The touchdown zone typically extends up to <strong>3,000 ft / 900m</strong> and it is the only safe portion of the runway to initiate touchdown. It is clearly marked on the pavement.</p>

            <h4>Pitch Limitations (Landing Phase)</h4>
            <p>It has been observed that some pilots are exceeding safe pitch limits during the landing flare, increasing the risk of tail strike. This is recorded in your Post Flight Report!</p>
            <p>Please adhere strictly to the following pitch limitations:</p>
            <ul>
                <li><strong>Airbus A320:</strong> Maximum pitch 10°</li>
                <li><strong>Airbus A321:</strong> Maximum pitch 7.5°</li>
            </ul>
            <p>Pilots should avoid exceeding these pitch limitations to aim for a smooth and/or butter landing, enhancing safety and passenger comfort.</p>

            <div class="fdm-warning">
                <p><strong>If you are not stabilized or cannot land within the touchdown zone:</strong></p>
                <p><strong>A go-around is MANDATORY!</strong></p>
                <p>This is not optional — it is the safest and most professional course of action.</p>
            </div>

            <h4>Non-Compliance</h4>
            <div class="fdm-warning">
                <p>Failure to comply will result in FDM Action.</p>
                <p>Any flight reports showing landings outside the touchdown zone or exceeding pitch limitations without proper justification will be subject to manual review and <strong>PIREP Invalidation!</strong></p>
            </div>

            <p>Please adhere with the published SOPs and company/aircraft limitations.</p>

            <p class="fdm-author"><strong>Francisco</strong> – Chief Pilot | FDM Team</p>
        </div>
    </div>

    <!-- ENGINE MODAL -->
    <div id="modal-engine" class="fdm-modal">
        <div class="fdm-modal-content">
            <button class="fdm-modal-close">&times;</button>
            <h2>Engine Warm-Up/Cool-Down and Excessive Taxi Thrust</h2>
            <p class="modal-intro">The FDM team has reviewed this week's flights and identified ongoing issues regarding engine warm-up, cool-down procedures, and improper thrust application during single-engine taxi, particularly under high weight conditions.</p>

            <p>These procedures are critical to ensure aircraft integrity and must be followed precisely on all flights.</p>

            <h4>Engine Warm-Up Before Takeoff</h4>
            <p><strong>Both engines must operate at or near idle for 5 minutes before applying takeoff thrust.</strong></p>
            <ul>
                <li>If performing single-engine taxi, ensure that both engines operate at or near idle for 5 minutes before departure even if the second engine was started later during taxi</li>
                <li>This procedure helps prevent thermal shock and engine wear</li>
            </ul>

            <div class="fdm-note">
                <p><strong>Important Note:</strong> We are aware that in real-world operations, engine warm-up is not required if engines have been shut down for more than 2 hours. However, due to software limitations in VAMSYS, we cannot track this. As a result, <strong>a full 5-minute idle warm-up is mandatory for all flights</strong>, regardless of prior engine state.</p>
            </div>

            <h4>Engine Cool-Down After Landing</h4>
            <p>After landing, both engines must <strong>remain at idle for at least 3 minutes before shutdown</strong> to allow thermal stabilization.</p>
            <ul>
                <li><strong>If 40% N1 (NEO) / 1.03 EPR (CEO) was exceeded, the 3 mins timer must be restarted!</strong></li>
                <li>Remember to start timer only when passing <strong>70 kt IAS (Indicated Airspeed)</strong></li>
            </ul>
            <p>Routine cooling periods that last less than the specified time can result in engine degradation.</p>

            <h4>High Thrust Use During Single-Engine Taxi</h4>
            <p>During single-engine taxi at high gross weight, avoid high thrust settings to move the aircraft.</p>
            <ul>
                <li>Use only minimal required thrust, plan for slower taxi, and anticipate turns to avoid abrupt stops</li>
                <li>Excessive thrust during taxi can cause FOD ingestion, brake wear, reduce engine life and passenger discomfort</li>
                <li>If extra thrust needed to taxi, start engine #2</li>
            </ul>

            <h4>Non-Compliance Penalties</h4>
            <div class="fdm-warning">
                <p><strong>Failure to comply with these procedures will result in penalty points on your PIREP.</strong></p>
                <p>Continued violations and/or actions will result in PIREP invalidation.</p>
            </div>

            <div class="fdm-success">
                <p><strong>Quick Compliance Tips:</strong></p>
                <ul>
                    <li>Set a 5-minute timer at engine start and a 3-minute timer after landing</li>
                    <li>Start your second engine early enough during taxi to meet the 5-minute warm-up rule</li>
                    <li>If too heavy, consider the use of both engine taxi at departure to avoid unnecessary high Engine Thrust</li>
                    <li>Don't rush your taxi and plan accordingly!</li>
                </ul>
            </div>

            <p class="fdm-author"><strong>Francisco</strong> – Chief Pilot | FDM Team</p>
        </div>
    </div>

    <!-- STABILIZATION MODAL -->
    <div id="modal-stabilization" class="fdm-modal">
        <div class="fdm-modal-content">
            <button class="fdm-modal-close">&times;</button>
            <h2>Mandatory Compliance with Stabilization Criteria & Correct Configuration Sequence</h2>
            <p class="modal-intro">Recent flight data reviews during the past week have shown cases of pilots not complying with stabilization criteria and correct configuration sequencing during approach phase. This is a serious FDM Finding.</p>

            <h4>What is the Stabilization Criteria and a Stabilized Approach?</h4>
            <p>A stabilized approach means the aircraft is on the correct flight path, at the correct speed, descent rate, and configuration, with minimal deviations according to procedures, by a specific altitude:</p>
            <ul>
                <li><strong>1000 feet above aerodrome level (AAL)</strong> for VMC/IMC approaches</li>
                <li><strong>500 feet AAL</strong> for circling approaches</li>
            </ul>

            <h4>Why Is This Important?</h4>
            <ul>
                <li>Prevents unstable, rushed, or unsafe landings</li>
                <li>Reduces risk of hard landings, runway excursions, or loss of control</li>
                <li>Reflects real-world SOPs (Standard Operating Procedures) and airline safety standards</li>
            </ul>

            <h4>Stabilization Criteria – Mandatory Compliance</h4>
            <p><strong>All approaches must be fully stabilized by 1000ft AAL in IMC/VMC or 500ft AAL for circling approaches.</strong></p>
            <p>This means:</p>
            <ul>
                <li><strong>On the correct lateral flight path</strong> – Aligned with the runway centerline or approach course</li>
                <li><strong>On the correct vertical path</strong> – Following glide slope, descent path, or visual descent guidance</li>
                <li><strong>Proper speed</strong> – Within approach speed limits (usually within -5 / +10 knots of target). Temporary speed fluctuations are acceptable down to 300ft AAL</li>
                <li><strong>Stable descent rate</strong> – Not exceeding 1000 feet per minute unless briefed and justified by a specific procedure</li>
                <li><strong>Landing configuration</strong> – Gear down, flaps in landing position, spoilers Armed</li>
                <li><strong>Checklist completion</strong> – Landing checklist should be completed prior to the stabilization altitude (ECAM Memo)</li>
                <li><strong>No excessive flight control inputs</strong> – Minimal and smooth corrections — aircraft must be under control at all times</li>
            </ul>

            <div class="fdm-warning">
                <p><strong>If the aircraft does not meet all criteria by the required altitude, the PIC must execute a go-around.</strong></p>
            </div>

            <h4>Configuration Sequence – DO NOT Lower Gear After Flaps FULL</h4>
            <p>The correct landing configuration sequence must be followed:</p>
            <p class="fdm-prohibited"><strong>Lowering the landing gear after Flaps FULL is NOT according SOP.</strong></p>
            <p class="fdm-approved"><strong>Ensure gear down is selected before selecting Flaps FULL.</strong></p>
            <p>This is in line with real-world procedure and avoids destabilizing the approach and/or triggering a Master Warning.</p>
            <p><strong>As Pilot In Command, you are responsible to comply with these procedures as published by SOP.</strong></p>

            <div class="fdm-warning">
                <p><strong>Please note that Non-compliance with Stabilization Criteria will result in PIREP Invalidation.</strong></p>
            </div>

            <p>Your attention to these procedures is crucial in maintaining the realism and high standards of vWZZ operations.</p>

            <p class="fdm-author"><strong>Francisco</strong> – Chief Pilot | Flight Data Monitoring Team</p>
        </div>
    </div>

    <!-- FUEL MODAL -->
    <div id="modal-fuel" class="fdm-modal">
        <div class="fdm-modal-content">
            <button class="fdm-modal-close">&times;</button>
            <h2>Minimum Off Block Fuel (MOBF)</h2>
            <p class="modal-intro">Recent flight data reviews have shown cases of aircraft departing with less than the required Minimum Off Block Fuel (MOBF). This is a serious deviation from operational standards.</p>

            <h4>Background</h4>
            <p>The flight is divided in 2 major phases, Planning Stage and Inflight Stage.</p>
            <p><strong>Planning Stage:</strong> The Pilot In Command (PIC) should calculate the Minimum Required Off Block Fuel (MOBF) required to perform the flight, depending on route, weights, weather forecasts, cruise altitudes, etc. (This is done automatically for you when you generate an OFP so no need to worry).</p>
            <p><strong>Inflight Stage:</strong> The only legal requirement is not to land below the Final Reserve Fuel specified in your OFP. Fuel management inflight is solely responsibility of PIC. (Inflight stage commences once the aircraft starts moving under its own power).</p>

            <h4>What is MOBF?</h4>
            <p>MOBF is the minimum required fuel onboard before engine start and pushback. It includes:</p>
            <ul>
                <li>Trip fuel</li>
                <li>Contingency</li>
                <li>Alternate</li>
                <li>Final reserve</li>
                <li>Taxi fuel</li>
                <li>ADD Fuel (Calculated by dispatch for specific regulatory compliance, if applicable)</li>
                <li>ARRDLY (Calculated by dispatch for arrival delays, if applicable)</li>
            </ul>
            <p>Extra fuel that's uplifted by PIC discretion is added to MOBF and it will become part of Plan Block Fuel.</p>
            <p><strong>It's listed clearly in SimBrief OFP as MIN BLOCK.</strong></p>

            <div class="fdm-warning">
                <p><strong>Flights departing with fuel below MOBF will be Invalidated!</strong></p>
                <p>Departing below this limit is non-compliant with our operational policy and a severe FDM finding which will result in PIREP Invalidation.</p>
            </div>

            <p>This is done to maintain:</p>
            <ul>
                <li>Realism</li>
                <li>Safety</li>
                <li>Professionalism in vWZZ operations</li>
            </ul>

            <h4>What to Do</h4>
            <ul>
                <li>Always verify your loaded fuel meets or exceeds at least MIN BLOCK</li>
                <li>If you decide to take minimum fuel, always round up the Min Block to the highest one-hundredth (i.e. Min Block is 6931 kg as per OFP, so round up to 7000 kg)</li>
            </ul>

            <h4>Scenarios to Consider Taking More Fuel</h4>
            <p>Respecting MTOW and MLW:</p>
            <ul>
                <li>If delays expected at departure airport (For info, APU on the ground consumes ± 150 kg/h)</li>
                <li>If significant weather at departure/arrival airport</li>
                <li>If runway closure is a factor (i.e. Runway cleaning during snow fall)</li>
                <li>Rush hour during airport movements</li>
                <li>On ACDM Airports with big CTOTs and TSATs</li>
                <li>Whenever deemed necessary by PIC for the safety of the flight</li>
            </ul>

            <div class="fdm-warning">
                <p><strong>Remember: Never pushback below MOBF!</strong></p>
            </div>

            <div class="fdm-images fdm-images-single">
                <img src="/images/fdm/minblock.png" alt="SimBrief OFP MIN BLOCK example">
            </div>

            <p class="fdm-author"><strong>Francisco</strong> – Chief Pilot | Flight Data Monitoring Team</p>
        </div>
    </div>

    <!-- CHISINAU MODAL -->
    <div id="modal-chisinau" class="fdm-modal">
        <div class="fdm-modal-content">
            <button class="fdm-modal-close">&times;</button>
            <h2>Chișinău (LUKK) - RWY 09/27 Restriction</h2>
            <p class="modal-intro">The FDM team has identified a new threat for our operations: incorrectly using RWY 09/27 for take-off and landing at Chișinău.</p>

            <p>To ensure realistic and compliant vWZZ operations, please note the following important aerodrome limitation.</p>

            <h4>RWY 09/27 Status</h4>
            <p class="fdm-prohibited">RWY 09/27 is NOT an active runway for normal operations.</p>
            <p class="fdm-approved">Under standard conditions, RWY 09/27 functions as Taxiway D (TWY D).</p>

            <h4>When Can RWY 09/27 Be Used?</h4>
            <ul>
                <li>ONLY when RWY 08/26 is closed</li>
                <li>Closure must be explicitly stated by NOTAMs</li>
            </ul>
            <p>Unless a NOTAM clearly indicates RWY 08/26 unavailable, crews must treat 09/27 strictly as a taxiway.</p>

            <h4>Not Permitted During Normal Operations</h4>
            <ul>
                <li class="fdm-prohibited">Departing from RWY 09/27</li>
                <li class="fdm-prohibited">Landing on RWY 09/27</li>
                <li class="fdm-prohibited">Planning it in the FMC/MCDU as an active runway</li>
                <li class="fdm-prohibited">Using it as a shortcut or improvised departure</li>
            </ul>
            <p>Even if selectable in-sim or suggested by default ATC, it remains non-operational.</p>

            <h4>Why This Matters</h4>
            <p>Using a taxiway as a runway may result in:</p>
            <ul>
                <li>Unrealistic operations</li>
                <li>Reduced safety margins</li>
                <li>FDM penalties and invalid PIREPs</li>
            </ul>
            <p>Professional operations must always follow published aerodrome usage and NOTAM status.</p>

            <h4>Non-Compliance Penalties</h4>
            <div class="fdm-warning">
                <p>Failure to comply will result in:</p>
                <ul style="margin: 8px 0 0 18px; padding: 0;">
                    <li>Penalty points on your PIREP</li>
                    <li>Possible PIREP invalidation</li>
                    <li>Repeated violations subject to review</li>
                </ul>
            </div>

            <div class="fdm-success">
                <p><strong>Quick Compliance Tips:</strong></p>
                <ul>
                    <li>Always check NOTAMs during pre-flight planning</li>
                    <li>Plan RWY 08/26 as the primary runway</li>
                    <li>Treat 09/27 as Taxiway D by default</li>
                    <li>Do not accept 09/27 for take-off/landing unless officially closed 08/26</li>
                </ul>
            </div>

            <p><strong>If it looks like a runway but charts/NOTAMs say taxiway — it's a taxiway.</strong></p>

            <div class="fdm-images fdm-images-single">
                <img src="/images/fdm/chis1.png" alt="Chișinău Airport RWY 09/27 Reference">
            </div>

            <p class="fdm-author"><strong>Dejw</strong> – Flight Operations Manager | FDM Team</p>
        </div>
    </div>
`;

